<template>
	<div class="photo-header-list">
		<v-container class="primary photo-header-list-layout">
			<v-layout align-center justify-start row fill-height>
				<v-text-field dark clearable height="23" placeholder="名前で検索" color="white" single-line class="ma-0" @input="onChangeFilterText"></v-text-field>
			</v-layout>
		</v-container>
	</div>
</template>
<script>

export default {
	name: 'GBPhotoAlbumListScheduleHeader',
	props: [
	],
	data () {
		return {
		}
	},
	methods: {
		onChangeFilterText: function(e) {
			this.$emit('change-list-filter-text', e);
		},
	},
	computed: {
	},
};
</script>
<style>
	.photo-header-list {
		flex: 0 0 300px !important;
		position: relative;
		border:solid 1px #DFDFDF;
		height: 59px;
		width: 300px;
		border-left: none;
	}
	.photo-header-list-layout {
		position: relative;
		padding: 16px 19px 0px 10px;
		height: 57px;
	}
</style>
